import React, { useEffect, useState } from "react";
import "../styles/RepProfile.css";
import { useNavigate } from "react-router-dom";

function RepProfile() {
  const [representative, setRepresentative] = useState({});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reason, setReason] = useState("");
  const [holidaysAcceptedCount, setHolidaysAcceptedCount] = useState("");
  const [allHolidaysRequests, setAllHolidaysRequests] = useState([]);
  const [acceptedHolidayRequests, setAcceptedHolidayRequests] = useState([]);
  const navigate = useNavigate();

useEffect(() => {
  // Get user from session storage
  const user = JSON.parse(sessionStorage.getItem('user'));
  
  // If no user found or user is not a representative, redirect to login
  if (!user || user.role !== 'representative') {
    navigate('/Login');
    return;
  }
  
  getRepresentativeData(user.id);
}, [navigate]);


useEffect(() => {
  if (representative._id) {
    getRepresentativeHolidays();
  }
}, [representative._id]);

  const handleLogout = () => {
    // Clear the auth token cookie
    document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    
    // Clear user data from session storage
    sessionStorage.removeItem('user');
    
    // Redirect to login page
    navigate('/Login');
  };

  const handleHolidaySubmit = async (event) => {
    event.preventDefault();

    if (!startDate || !endDate || !reason) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/holiday-requests/create-request",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            representative: representative._id,
            startDate,
            endDate,
            reason,
            status: "pending",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to save Holiday");
      }

      getRepresentativeHolidays();
      setStartDate("");
      setEndDate("");
      setReason("");
      alert("Holiday request submitted successfully!");
    } catch (error) {
      console.error("Error saving Holiday:", error);
    }
  };

  const getRepresentativeHolidays = async () => {
    
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/holiday-requests/summary",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            representativeId: representative._id,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to get Holiday");
      }

      const data = await response.json();
      console.log(data);
      setAllHolidaysRequests(data.data.allHolidayRequests);
      setHolidaysAcceptedCount(data.data.total_days_taken);
      // Store accepted holiday requests
      setAcceptedHolidayRequests(data.data.acceptedHolidayRequests || []);
    } catch (error) {
      console.error("Error getting Holiday:", error);
    }
  };

  async function getRepresentativeData(userId) {
    try {
      const response = await fetch(
        `https://cairomed-backend.vercel.app/api/representatives/getRepresentative/${userId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch representatives data");
      }
      const data = await response.json();
      setRepresentative(data);
    } catch (error) {
      console.error("Error fetching representatives:", error);
    }
  }

  return (
    <div className="rep-profile container">
      <div className="selected-representative-profile">
        <div className="repProfile-header">
          <div className="repProfile-pic-box">
            <picture>
              <img src={representative.Image} alt="" />
            </picture>
            {representative.NameEN || "N/A"}
            <button className="cancel-btn" onClick={handleLogout}><i className="fa-solid fa-right-from-bracket"></i><span>logout</span></button>
          </div>
          <div className="profile-small-box-container">
            <div className="profile-small-box"><span>ID</span>{representative._id || "N/A"}</div>
            <div className="profile-small-box"><span>Email</span>{representative.email || "N/A"}</div>
            <div className="profile-small-box"><span>Phone Number</span>{representative.PhoneNumber || "N/A"}</div>
            <div className="profile-small-box"><span>Region</span>{representative.AreaEN || "N/A"}</div>
          </div>
        </div>

        {/* Holidays Table */}
        <div className="table-wrapper">
          <h3>Holiday Requests</h3>
          <table className="table">
            <thead>
              <tr>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Reason</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {allHolidaysRequests.length > 0 ? (
                allHolidaysRequests.map((holiday) => (
                  <tr key={holiday._id}>
                    <td>{new Date(holiday.startDate).toLocaleDateString()}</td>
                    <td>{new Date(holiday.endDate).toLocaleDateString()}</td>
                    <td>{holiday.reason}</td>
                    <td className={`status-${holiday.status}`}>{holiday.status}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No holidays found...</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="Targets-box">
          <h2>Targets</h2>
          <div>
            {representative.targets?.map((target) => (
              <div key={target._id}>
                <h4>{target.product.ProductNameEN}</h4>
                <div className="progress mt-2">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow={target.progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: `${target.progress}%` }}
                  >
                    {target.progress}%
                  </div>
                </div>
                <div className="d-flex justify-content-between mt-1 mb-1">
                  <div className="d-flex flex-column"><span>Achieved</span><span>{target.achived}</span></div>
                  <div className="d-flex flex-column"><span>Target</span><span>{target.target}</span></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Holiday Request Section */}
      <div className="holiday-box">
        <h3>Holidays</h3>
        <div className="Annual-Leave-box">
          <p>Annual Leave</p>
          <h4>{holidaysAcceptedCount}/25 <span>Days</span></h4>
          <a href="#" data-bs-toggle="modal" data-bs-target="#previousLeaveModal">Previous Leave Record</a>
        </div>
        <button data-bs-toggle="modal" data-bs-target="#exampleModal">Request Leave</button>
      </div>

      {/* Modal for Holiday Request */}
      <div className="modal fade holiday-modal" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Request Leave</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleHolidaySubmit}>
                <label htmlFor="startDate">Start Date</label>
                <input type="date" id="startDate" value={startDate} onChange={(e) => setStartDate(e.target.value)} required />
                <label htmlFor="endDate">End Date</label>
                <input type="date" id="endDate" value={endDate} onChange={(e) => setEndDate(e.target.value)} required />
                <label htmlFor="reasonInput">Reason</label>
                <input type="text" id="reasonInput" value={reason} onChange={(e) => setReason(e.target.value)} required />
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  <button type="submit" className="btn btn-primary">Save changes</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Previous Leave Records */}
      <div className="modal fade holiday-modal" id="previousLeaveModal" tabIndex="-1" aria-labelledby="previousLeaveModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="previousLeaveModalLabel">Previous Accepted Leave Records</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Days</th>
                      <th>Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    {acceptedHolidayRequests.length > 0 ? (
                      acceptedHolidayRequests.map((holiday) => {
                        const startDate = new Date(holiday.startDate);
                        const endDate = new Date(holiday.endDate);
                        const days = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
                        
                        return (
                          <tr key={holiday._id}>
                            <td>{startDate.toLocaleDateString()}</td>
                            <td>{endDate.toLocaleDateString()}</td>
                            <td>{days}</td>
                            <td>{holiday.reason}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">No accepted holidays found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RepProfile;
